import React from 'react';
import { Container } from 'reactstrap';
import { Link } from 'gatsby';

import CollapsibleCard from '../../../CollapsibleCard';
import AwsSolutionsCard from '../../../AwsSolutionsCard';
import { CONTACT_ROUTE } from '../../../../routes';

const STEPS = [
  {
    title: 'Machine Learning',
    stripeColor: 'blue',
    className: 'blue CollapsibleCard--bg-offwhite',
    text:
      'A subset of artificial intelligence, machine learning is the training of computer systems to perform a task without using explicit instructions.',
  },
  {
    title: 'Serverless',
    stripeColor: 'orange',
    text:
      'Building modern applications with the lowest cost of total ownership. Serverless designs eliminates the need for traditional infrastructure management, maintenance and provisioning.',
  },
  {
    title: 'Mobile',
    stripeColor: 'dark-blue',
    text:
      'Expand your Multi-Tenant SaaS web application with our mobile services. Deploy iOS and Android apps that compliment your bussiness needs.',
  },
  {
    title: 'Multi-Tenant Web App',
    stripeColor: 'green',
    text:
      'Consolidate your web services into a single multi tenant web application for users to access.  Gain the scalability and cost savings with Cloudnexa\'s SaaS web application development service.',
  },
];

const DevServices = () => {
  return (
    <div className="DevServices">
      <Container>
        <h2 className="DevServices__title">
          <span className="text-blue">Modern</span>
          &nbsp;Application Development
        </h2>

        <div className="DevServices__lead">
          Let Cloudnexa build and design your next web application with one of
          our competencies
        </div>

        <div className="d-flex flex-column flex-md-row flex-md-wrap align-items-md-stretch">
          {STEPS.map((item, idx) => (
            <div
              className="w-100 w-md-50 w-lg-25 mb-3 pl-md-2 pr-md-2"
              key={idx}
            >
              <CollapsibleCard
                {...item}
                isOpenDefault={idx === 1}
                className="CollapsibleCard--bg-offwhite DevService"
              >
                {item.text}

                <div className="DevService__link">
                  <Link to={CONTACT_ROUTE}>Get Started Now</Link>
                </div>
              </CollapsibleCard>
            </div>
          ))}
        </div>

        <div className="d-md-flex flex-xs-column justify-content-between pt-md-3 pt-md-4 align-items-lg-center">
          <div className="text-md-left w-md-50 pl-lg-3">
            <h3 className="DevServices__learnMoreTitle">
              <span className="text-blue">Want to</span>&nbsp;Learn More?
            </h3>

            <div className="DevServices__learnMoreLead">
              Check Out Our AWS Managed Solutions
            </div>
          </div>

          <div className="w-lg-50">
            <AwsSolutionsCard />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default DevServices;
